/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import L from "./Lang"
import BaseCom from "./BaseCom";
import DataTable from "./DataTable";
import LoadingAlert from "./LoadingAlert";
import Paging from "./Paging";
import { qreq } from "../shared/qrequest";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as fa from '@fortawesome/free-solid-svg-icons';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import { withParamsAndNavigate } from "./WithParamsAndNavigate";
import Alert from "./Alert";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import FormLabel from "./FormLabel";
import DocumentList from "./DocumentList"
import { Tooltip } from "react-tooltip";
import Tutorial from "../shared/Tutorial";
import Globals from "../shared/Globals";
import { SidebarGlobal } from "./_SidebarGlobal";
import FormInput from "./FormInput";
import { Link, NavLink } from "react-router-dom";
import { TabsNav } from "./TabsNav";
import Icon from "./Icon";
import SharedUtil from "../shared/SharedUtil";
import Auth from "../shared/Auth";
import AppActions from "./AppActions";

class OrdersMenu extends BaseCom {
    async componentDidMount() {
        await this.getSettings();
    }

    render() {
        // Not used in UDHS
        if (this.state.MODEL === 'EHR')
            return;
        return <>
            <TabsNav>
                <li className="nav-item"><NavLink to="/order/list" className="nav-link" role="tab" aria-selected="true"><L>Active</L> <span className="d-none d-md-inline"><L>Patients</L></span></NavLink></li>
                <li className="nav-item"><NavLink to="/order/discharge" className="nav-link" role="tab" aria-selected="true"><L>Discharged</L> <span className="d-none d-md-inline"><L>Patients</L></span></NavLink></li>
            </TabsNav>
        </>;
    }
}

class Orders extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            query: {
                page: 1,
                published: true,
                more: true,
                fast: false,
                sort: 'o.createddate DESC',
                qfilters: {}
            },
            list: [],
            loaded: false,
            loading: false,
            nextLoc: null,
            filters: {},
            accountList: [],
            statusList: [],
            panelList: [],
            showFilters: false,
            uploadItem: {},
            orderLoading: false,
            order: {
                patient: {},
                documents: []
            },
            showUploadModal: props.showUploadModal,
            showTutorial: false
        };
        if (this.props.params) {
            if (this.props.params.page)
                this.state.query.page = Number(this.props.params.page);
        }
        this.load = this.load.bind(this);
        this.loadStatuses = this.loadStatuses.bind(this);
        this.toggleFilter = this.toggleFilter.bind(this);
        this.onSort = this.onSort.bind(this);
        this.onFilter = this.onFilter.bind(this);
        this.search = this.search.bind(this);
        this.selectAll = this.selectAll.bind(this);
        this.selectNone = this.selectNone.bind(this);
        this.doAction = this.doAction.bind(this);
        this.upload = this.upload.bind(this);
        this.loadOrder = this.loadOrder.bind(this);
        this.onFileDrop = this.onFileDrop.bind(this);
        this.onFileDragOver = this.onFileDragOver.bind(this);
        this.onFileDragLeave = this.onFileDragLeave.bind(this);
    }

    // Loaders

    load(query) {
        if (!query)
            query = { ...this.state.query };
        this.setState({ loading: true });
        query.qfilters.TreatmentEnded = (this.props.type === 'discharge' ? 'true' : 'false'); // active or discharge list
        if (this.props.accountID)
            query.qfilters.AccountID = this.props.accountID;
        qreq.post('/api/order/list', query, j => {
            if (!j.errorCode) {
                j.list.forEach((i) => {
                    if (i.createdDate === '01/01/0001 00:00') i.createdDate = 'No Date Recorded';
                    i.className = i.statusColor;
                });
                if (j.list.length === 0 && !this.state.query.more) {
                    this.state.query.more = true;
                    this.setState({ query: this.state.query });
                    this.load();
                }
                else {
                    this.setState({ list: j.list, loaded: true, loading: false, pageCount: j.pageCount, totalCount: j.totalCount });
                    if (j.totalCount > 30 && j.list.length < 30 && !this.state.query.more) {
                        this.state.query.more = true;
                        this.setState({ query: this.state.query });
                        this.load();
                    }
                }
            }
        }, e => {
            this.setState({ loading: false });
        });
    }

    loadStatuses() {
        qreq.get('/api/order/status/list', j => {
            if (!j.errorCode) {
                var list = [];
                j.list.forEach(i => {
                    list.push({ id: i, name: i });
                });
                this.setState({ statusList: list });
            }
        });
    }


    // Filter

    toggleFilter() {
        var currentState = this.state.showFilters;
        this.state.query.qfilters = {};
        this.setState({ showFilters: !currentState, filters: {}, query: this.state.query });

        if (currentState)
            this.load();
    }

    onFilter(col) {
        var filters = { ...this.state.filters };

        if (col.filter.filter === 'createddate') this.dateFilter(filters, ['CreatedStartDate', 'CreatedEndDate'], col.filter.value);
        else if (col.filter.filter === 'receiveddate') this.dateFilter(filters, ['ReceivedStartDate', 'ReceivedEndDate'], col.filter.value);
        else if (col.filter.filter === 'releaseddate') this.dateFilter(filters, ['ReleasedStartDate', 'ReleasedEndDate'], col.filter.value);
        else {
            if (col.filter.value)
                filters[col.filter.filter] = col.filter.value;
            else
                delete filters[col.filter.filter];
        }
        var query = { ...this.state.query, qfilters: filters };
        this.setState({ filters: filters, query: query });
        this.load(query);
    }

    dateFilter(filters, varNames, val) {
        var n = 0;
        if (val) {
            varNames.forEach(i => {
                filters[i] = val[n];
                n++;
            });
        }
        else {
            varNames.forEach(i => {
                delete filters[i];
            });
        }
    }

    search(e) {
        if (e)
            e.preventDefault();

        if (this.loading) {
            setTimeout(() => this.search(), 100);
            return;
        }

        if (this.searchTimeout)
            clearTimeout(this.searchTimeout);

        this.searchTimeout = setTimeout(() => {
            this.load();
        }, 1000);
    }

    // Sort

    onSort(col) {
        var name = col.name;


        if (name === 'patientNameDOB')
            name = 'UPPER(p.firstname||\' \'||p.lastname)';
        else if (name === 'accountName')
            name = 'a.name';
        else if (name === 'assignedToNames')
            name = 'p.assignedtonames';
        else if (name === 'phase')
            name = 'ph.name';
        else {

            if (name === 'oid')
                name = 'id';
            else if (name === 'status')
                name = 'status';
            else
                name = name.charAt(0).toUpperCase() + name.slice(1);

            name = 'o.' + name.toLowerCase();
        }

        this.state.query.sort = name + ' ' + (col.asc ? 'ASC' : 'DESC');
        this.setState({ query: this.state.query });
        this.load();
    }

    // More Actions

    selectAll() {
        this.state.list.forEach(i => {
            i.selected = true;
        });
        this.setState({ list: this.state.list, showFilters: true });
    }

    selectNone() {
        this.state.list.forEach(i => {
            i.selected = false;
        });
        this.setState({ list: this.state.list, showFilters: true });
    }

    doAction(action) {
        var ids = [];
        this.state.list.forEach(i => {
            if (i.selected)
                ids.push(i.id);
        });
        if (action === 'toggleStat') {
            qreq.post('/api/order/toggle/stat', ids, j => {
                if (!j.errorCode)
                    this.load();
            });
        }
        else if (action === 'togglePriority') {
            qreq.post('/api/order/toggle/priority', ids, j => {
                if (!j.errorCode)
                    this.load();
            });
        }
        else if (action === 'reject') {
            qreq.post('/api/order/reject/multiple', ids, j => {
                if (!j.errorCode)
                    this.load();
            });
        }
        else if (action === 'disclaimer') {
            qreq.post('/api/order/disclaimer/multiple', ids, j => {
                if (!j.errorCode)
                    this.load();
            });
        }
        else if (action === 'newIssue') {
            qreq.post('/api/order/issue/create/multiple', ids, j => {
                if (!j.errorCode)
                    this.load();
            });
        }
        else if (action === 'resync') {
            qreq.post('/api/order/resync/multiple', ids, j => {
                if (!j.errorCode)
                    this.load();
            });
        }
        else if (action === 'resendToInstruments') {
            qreq.post('/api/order/resend/multiple', ids, j => {
                if (!j.errorCode)
                    this.load();
            });
        }
    }

    loadOrder(id) {
        this.setState({ orderLoading: true });
        if (this.state.order && this.state.order.id !== id)
            this.setState({
                order: {
                    patient: {},
                    documents: []
                }
            });
        qreq.get('/api/order/get/' + id, j => {
            if (j.item) {
                Globals.processResultObject(j);
                this.setState({ order: j.item, orderLoading: false });
            }
        });
    }


    upload(e) {
        Tutorial.complete('patient-uploadrequest');
        this.setState({ uploading: true, showTutorialUploadRequest: false });
        var reader = new FileReader();
        reader.readAsBinaryString(e.target.files[0]);
        reader.onload = () => {
            var b64data = btoa(reader.result);
            qreq.post('/api/order/document/upload', { orderID: this.state.order.id, visitID: 0, fileName: e.target.files[0].name, mimeType: e.target.files[0].type, dataSize: e.target.files[0].size, base64Content: b64data, documentCategoryID: this.state.uploadItem.documentCategoryID }, j => {
                if (j.errorCode === 0) {
                    this.setState({ uploading: false });
                    this.loadOrder(this.state.order.id);
                }
                else {
                    this.alert(j.errorMessage);
                    this.setState({ uploading: false });
                }
                e.target.value = '';
            });
        };
        reader.onerror = (error) => {
            console.log('Error: ', error);
            this.setState({ uploading: false });
            e.target.value = '';
        };

    }

    onFileDrop(e) {
        e.preventDefault();


        document.querySelectorAll('.c-dropzone').forEach(i => {
            i.classList.remove('active');
        });

        if (!this.state.order || !this.state.order.id)
            return;


        if (e.dataTransfer && e.dataTransfer.items) {
            [...e.dataTransfer.items].forEach(i => {
                if (i.kind === "file") {
                    const file = i.getAsFile();
                    this.upload({
                        target: {
                            files: [file],
                            value: ''
                        }
                    });
                }
            });
        }
    }

    onFileDragOver(e) {
        e.preventDefault();
        if (this.leaveTimeout)
            clearTimeout(this.leaveTimeout);
        document.querySelectorAll('.c-dropzone').forEach(i => {
            i.classList.add('active');
        });
    }

    onFileDragLeave(e) {
        e.preventDefault();
        if (this.leaveTimeout)
            clearTimeout(this.leaveTimeout);
        this.leaveTimeout = setTimeout(() => {
            document.querySelectorAll('.c-dropzone').forEach(i => {
                i.classList.remove('active');
            });
        }, 500);
    }

    // Overrides

    async componentDidMount() {
        await this.getSettings();

        if (this.props.init) {
            setTimeout(() => {
                this.props.navigate('/order/list');
            }, 100);
        }

        if (this.props.params.filter) {
            var qfilters = JSON.parse(window.atob(this.props.params.filter));
            var query = { ...this.state.query, qfilters: qfilters };
            this.setState({ query: query });
            this.load(query);
        }
        else
            this.load();
        this.loadStatuses();


        if (this.props.params && this.props.params.id) {
            this.loadOrder(this.props.params.id);
        }

        qreq.get('/api/order/document-category/list', j => {
            if (j.list) {
                j.list.forEach(i => {
                    if (i.name === 'Wound Care Request') {
                        this.state.uploadItem.documentCategoryName = i.name;
                        this.state.uploadItem.documentCategoryID = i.id;
                        this.setState({ uploadItem: this.state.uploadItem });
                    }
                });
                this.setState({ categories: j.list });
            }
            else if (j.errorCode !== 0)
                this.alert(j.errorMessage);
        }, () => {
            this.alert('Unknown error ocurred getting document categories.');
        });


        if (!this.props.com) {
            Tutorial.checkCompleted('patient-new', b => {
                this.setState({ showTutorial: !b });
            });
            Tutorial.checkCompleted('patient-uploadrequest', b => {
                this.setState({ showTutorialUploadRequest: !b });
            });
            SidebarGlobal.setSubNav(<><div className="btn-group me-2">
                {!Auth.hasRole('readonly') && <button type="button" className="btn btn-primary" onClick={() => this.props.navigate('/order/new')} data-tooltip-id="t-tutorial-create"><FontAwesomeIcon icon={fa.faPlus} /> <span className="d-none d-sx-inline"><L>New</L></span></button>}
                <button type="button" className="btn btn-secondary" onClick={() => this.load()}><FontAwesomeIcon icon={fa.faRefresh} /> <span className="d-none d-sx-inline"><L>Refresh</L></span></button>
                <button type="button" className={'btn ' + (this.state.showFilters ? 'btn-info' : 'btn-secondary')} onClick={() => this.toggleFilter()}><FontAwesomeIcon icon={fa.faFilter} /> <span className="d-none d-sx-inline"><L>Filter</L></span></button>
            </div>
                <DropdownButton variant="primary" title="More" id="c-orders-dropdown" className="d-none">
                    <Dropdown.Item onClick={this.selectAll}><FontAwesomeIcon icon={fa.faCheckSquare} /><L>Select All</L></Dropdown.Item>
                    <Dropdown.Item onClick={this.selectNone}><FontAwesomeIcon icon={fa.faSquare} /><L>Select None</L></Dropdown.Item>
                </DropdownButton>
            </>);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.params.page !== this.props.params.page) {
            var query = { ...this.state.query, page: Number(this.props.params.page ?? 1) };
            this.setState({ query: query });
            this.load(query);
        }
        if (prevProps.type !== this.props.type) {
            this.load();
        }
    }

    componentWillUnmount() {
        if (!this.props.com)
            SidebarGlobal.clearSubNav();
    }

    downloadProgressReport = async (orderID) => {
        try {
            let available = await SharedUtil.progressReportAvailableAsync(orderID);
            if (available) {
                SharedUtil.downloadProgressReport(orderID);
            }
            else
                this.alert('The progress report is not available yet.');
        }
        catch (e) {
            this.unkownErrorCallback();
        }
    }

    showUploadModal = (order) => {
        this.loadOrder(order.id);
        this.setState({ showUploadModal: true });
    }

    exportList = () => {
        window.location.href = Globals.serverUrl + '/api/order/export';
    }

    render() {

        const header = !this.props.com ? (<h1>{this.props.type === 'discharge' ? 'Discharged Patients' : (this.state.MODEL === 'EHR' ? this.T('subject') + 's' : 'Active Patients')}</h1>) : '';
        if (!this.state.loaded)
            return (<div className="container-fluid">{header}<LoadingAlert /></div>);

        if (this.state.errorMessage)
            return <Alert type="danger" icon="ExclamationTriangle" message={this.state.errorMessage} />

        const columns = [
            {
                name: 'statusIcon', valueFunc: row => {
                    let ret = [];
                    if (row.status === 'Discharge' || row.treatmentEnded)
                        ret.push(<span className="d-block text-success"><FontAwesomeIcon icon={fa.faCheck} /></span>);
                    else if (row.status === 'IVR Result - OK' || row.readyToProcess)
                        ret.push(<span className="d-block text-success"><FontAwesomeIcon icon={fa.faPlay} /></span>);
                    else if (row.status === 'IVR Result - Need Info')
                        ret.push(<span className="d-block text-warning"><FontAwesomeIcon icon={fa.faTriangleExclamation} /></span>);
                    else if (row.status === 'IVR Result - Declined')
                        ret.push(<span className="d-block text-danger"><FontAwesomeIcon icon={fa.faTimes} /></span>);
                    else if (row.status === 'IVR Sent')
                        ret.push(<span className="d-block text-primary"><FontAwesomeIcon icon={fa.faPaperPlane} /></span>);
                    else
                        ret.push(<span className="d-block text-secondary"><FontAwesomeIcon icon={fa.faCircle} /></span>);


                    return ret;
                }
            },
            {
                name: 'oid', title: 'ID', className: 'd-none d-md-table-cell', valueFunc: row => {
                    return <span className="text-nowrap">{row.oid}</span>;
                }
            },
            { name: 'patientNameDOB', title: this.T('subject'), link: '/order/view/:id', tooltip: 'View ' + this.T('subject') },
            {
                name: 'status', title: 'Status', className: 'd-none d-md-table-cell', valueFunc: row => {
                    if (row.dischargeStatusID)
                        return row.dischargeStatusName;
                    return row.status;
                }
            },
            { name: 'accountName', title: 'Holder', className: 'd-none d-md-table-cell' },
            {
                name: 'assignedToNames', title: 'Assigned', className: 'd-none d-md-table-cell', valueFunc: row => {
                    if (!row.assignedToNames)
                        return 'Not Assigned';
                    return row.assignedToNames;
                }
            },
            { name: 'createdDate', title: 'Created', format: 'datetime', className: 'd-none d-md-table-cell' },
            {
                name: 'actions',
                title: 'Actions',
                className: 'd-none d-md-table-cell',
                valueFunc: row => (
                    <div className="d-flex gap-1 ms-2">
                        <Link title="View Patient" to={`/order/view/${row.id}`} className="btn btn-primary d-block"><Icon icon="faEye" /></Link>
                        {(Auth.hasRole('manager') || Auth.hasRole('account-manager'))
                            && <span title="Upload Documents" role="button" className="btn btn-secondary d-none d-md-block" onClick={() => this.showUploadModal(row)}><Icon icon="faFileUpload" /></span>}
                        <span title="Export Progress Report" role="button" className="btn btn-secondary d-block" onClick={() => this.downloadProgressReport(row.id)}><Icon icon="faFilePdf" /></span>
                    </div>
                ),
                noSort: true
            }
        ];

        if (this.state.MODEL === 'WMS' && (this.state.MODELPROPS?.indexOf('WOUND') >= 0 || this.state.MODELPROPS?.indexOf('LYMPH') >= 0)) {
            columns.splice(3, 0, {
                name: 'phase', title: 'Phase', valueFunc: row => {
                    if (!row.phase?.name)
                        return <span className="badge bg-secondary"><L>Pending</L></span>;
                    return <span className="badge" style={{ backgroundColor: row.phase?.color }}>{row.phase?.name}</span>;
                }
            });
        }



        return (<div className="container-fluid">
            {!this.props.com && <OrdersMenu />}
            {!this.props.com && <AppActions noBack containerContent={<Paging baseLoc={this.props.type ? '/order/' + this.props.type + '/list/page/' : '/order/list/page/'} pageCount={this.state.pageCount} currentPage={this.state.query.page} onPageClick={(e) => this.setState({ loading: true })} />}>
                {Auth.hasRole('admin') && <>
                    <button type="button" className="d-block d-md-none btn btn-secondary btn-lg" onClick={() => this.props.navigate('/menu')}>
                        <Icon icon="faBars" /> <L>Menu</L></button>
                    <Dropdown drop="up" className="d-block">
                        <Dropdown.Toggle variant="secondary" className="btn-lg"><L>Actions</L></Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item onClick={this.exportList}>
                                <Icon icon="faFileExcel" /> <L>Export</L></Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </>}
            </AppActions>}
            {header}
            <Modal show={this.state.showUploadModal} onHide={() => this.setState({ showUploadModal: false })} size="xl">
                <Modal.Header closeButton>
                    <Modal.Title><L>Upload a Document</L></Modal.Title>
                </Modal.Header>
                <form onSubmit={(e) => { e.preventDefault(); if (this.state.uploadItem.documentCategoryID) document.getElementById('c-documentrequests-upload').click(); else this.alert('Please select a Document Type.'); }}>
                    <Modal.Body>
                        {this.state.orderLoading ? <LoadingAlert /> : <>
                            <FormLabel model={this.state.order.patient.name} name="patientName" label={`${this.T('subject')} Name`} />
                            <DocumentList model={this.state.order} list={this.state.order.documents} edit showUploadButton={false} parentItem={this.state.order} uploadFunc={this.upload} />
                            <Tooltip
                                id="t-tutorial-uploadrequest"
                                content="Upload the patient request document. You may also drag-and-drop the document to this area."
                                isOpen={this.state.showTutorialUploadRequest}
                                place="top"
                                style={{ zIndex: 999 }}
                                variant="info"
                            />
                        </>}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => this.setState({ showUploadModal: false })} disabled={this.state.uploading || this.state.orderLoading}>
                            Close
                        </Button>
                        <button type="submit" data-tooltip-id="t-tutorial-uploadrequest" className="btn btn-primary" disabled={this.state.uploading || this.state.orderLoading}>
                            <FontAwesomeIcon icon={fa.faUpload} /><L>Select File</L></button>
                    </Modal.Footer>
                </form>
            </Modal>
            <div className="d-none"><input type="file" id="c-documentrequests-upload" onChange={this.upload} /></div>

            <Tooltip
                id="t-tutorial-create"
                content="To begin, start by creating your first patient."
                isOpen={this.state.showTutorial}
                place="bottom"
                style={{ zIndex: 999 }}
                variant="info"
            />

            <DataTable noStriped columns={columns} data={this.state.list} totalCount={this.state.totalCount} loading={this.state.loading} onSort={this.onSort} filters={[
                { name: 'status', title: 'Status', filter: 'status', type: 'select', options: this.state.statusList },
                { name: 'createdDate', title: 'Created Date', filter: 'createddate', type: 'daterange' }
            ]} showFilters={this.state.showFilters} onFilter={this.onFilter} showCheckboxes={this.state.showFilters} defaultSort="createdDate" defaultSortDesc
                sticky={!this.props.com} heightDelta={!this.props.com && 340}
                headerContent={<form onSubmit={this.search}>
                    <div className="mb-3">
                        <FormInput model={this.state.query} name="search" label={`Search for a ${this.T('subject').toLowerCase()}...`} labelAsPlaceholder onChange={() => { this.search(); }} />
                    </div>
                </form>}
            />
            <div className="card-body mt-2">

            </div>
        </div>);
    }
}

export default withParamsAndNavigate(Orders);